import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { config as siteConfig } from 'src/sites/config';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(): boolean {
        if (siteConfig.configuration.maintenance) {
            this.router.navigate(['/maintenance']);
            return false;
        }
        return true;
    }
}
